import uiNotificationService from 'services/uiNotification.service';

import * as companyApi from 'resources/company/company.api';
import userService from 'resources/user/user.service';

import { sendInvitation } from './invite';

export const createAndInviteManager = async ({ skipInvitation, ...data }) => {
  const isUserExists = await userService.checkIsUserExists(data.email);

  if (isUserExists) {
    uiNotificationService.showError('You are trying to invite an existing user.');
    return;
  }

  let manager = await userService.createNotInvitedUser({
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    type: data.type,
    companyId: data.companyId,
  });

  if (!skipInvitation) {
    const response = await sendInvitation({ id: manager.id, shouldSendEmail: true });
    manager = response.updatedUser;
  }

  companyApi.actualizeSubscriptionQty();

  uiNotificationService.showSuccess('Team member successfully added!');

  return manager;
};
